import {
  Brand as PatternflyBrand,
  type BrandProps as PatternflyBrandProps,
} from "@patternfly/react-core";
import useDarkModeEnabled from "../../shared/hooks/useDarkModeEnabled";
import { PropsWithChildren, useMemo } from "react";

export type BrandProps = Omit<PatternflyBrandProps, "src" | "alt"> &
  PropsWithChildren;
export default Brand;

const DARK_MODE_SRC = `${import.meta.env.BASE_URL}/assets/images/Logo-Red_Hat-Certification_Team-A-Reverse-RGB.png`;
const LIGHT_MODE_SRC = `${import.meta.env.BASE_URL}/assets/images/Logo-Red_Hat-Certification_Team-A-Standard-RGB.png`;

function Brand({ children, ...props }: Readonly<BrandProps>) {
  const darkModeEnabled = useDarkModeEnabled();
  const src = useMemo(
    () => (darkModeEnabled ? DARK_MODE_SRC : LIGHT_MODE_SRC),
    [darkModeEnabled],
  );
  return (
    <PatternflyBrand {...props} src={src} alt="Red Hat Exam Scheduler">
      {children}
    </PatternflyBrand>
  );
}
